export default "__VITE_ASSET__Bfwe4_rL__"